"use client";
import { useEffect, useState } from "react";

type PageChangeProps = {
  url: string
}

export default function PageChange({url}: PageChangeProps) {
  const [lastPage, setLastPage] = useState<string>()
  useEffect(() => {
    setLastPage(url)
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
  }, [url])
  return (<></>)
}